export const update = {
  updateSuccessfully: 'Update announcement successfully!',
}
